import { ViewModeHandle } from "./viewModeHandle";
import type { ViewModeDefinition } from "./view-modes-section-types";

export class ViewModesCollection {
	private handles: ViewModeHandle[] = [];

	public constructor(private readonly onRegistered?: (handle: ViewModeHandle) => void) {}

	public add(mode: ViewModeDefinition): ViewModeHandle {
		if(this.handles.some(handle => handle.code === mode.code)) {
			throw new Error(`Duplicate view-modes-mode code '${mode.code}'.`);
		}

		const handle = new ViewModeHandle(mode);
		this.handles.push(handle);
		this.onRegistered?.(handle);

		return handle;
	}

	public get all(): ReadonlyArray<ViewModeHandle> {
		return [...this.handles];
	}

	public get available(): ReadonlyArray<ViewModeHandle> {
		return this.handles.filter(mode => mode.isAvailable);
	}

	public get firstSelectable(): ViewModeHandle | undefined {
		return this.available.find(mode => mode.isSelectable);
	}

	public findAvailable(mode?: ViewModeHandle | string | null): ViewModeHandle | undefined {
		return this.available.find(handle => handle.isSame(mode));
	}

	public findSelectable(mode?: ViewModeHandle | string | null): ViewModeHandle | undefined {
		const handle = this.findAvailable(mode);
		return handle?.isSelectable ? handle : undefined;
	}

	public resolveMode(codes: ReadonlyArray<string | null | undefined>): ViewModeHandle | undefined {
		for(const code of codes) {
			const mode = this.findSelectable(code);
			if(mode) {
				return mode;
			}
		}

		return undefined;
	}
}
